<p-editor
  #editor
  [(ngModel)]="value"
  (ngModelChange)="valueChange.emit($event)"
  [modules]="editorModules"
  [readonly]="disabled"
  (paste)="onPaste.emit($event)"
  [styleClass]="styleClass"
  (onTextChange)="onTextChange.emit($event)"
  [style]="{ height: _height }"></p-editor>
